import {AfterContentInit, Component, Input} from '@angular/core';

/**
 * Component for the status badge
 * @class ContentStatusBadgeComponent
 * @implements {AfterContentInit}
 */
@Component({
  selector: 'advtech-content-status-badge',
  templateUrl: './content-status-badge.component.html',
})
export class ContentStatusBadgeComponent implements AfterContentInit {

  /**
   * Statuses and their icons and text
   *
   * @type {{draft: {icon: boolean; text: string}; live: {icon: boolean; text: string}; live-scheduled: {icon: string; text: string}; live_edited: {icon: string; text: string}; new: {icon: boolean; text: string}; past: {icon: boolean; text: string}; publish-scheduled: {icon: boolean; text: string}; published: {icon: boolean; text: string}; scheduled: {icon: boolean; text: string}; unpublished: {icon: boolean; text: string}; upublished-changes: {icon: string; text: string}}}
   */
  static statusTypes: {} = {
    "draft": {
      icon: false,
      text: 'DRAFT',
    },
    "live": {
      icon: false,
      text: 'LIVE',
    },
    "live_edited": {
      icon: 'fa-edit',
      text: 'LIVE',
    },
    "live_scheduled": {
      icon: 'fa-clock-o',
      text: 'LIVE',
    },
    "new": {
      icon: false,
      text: 'NEW',
    },
    "past": {
      icon: false,
      text: "PAST",
    },
    "publish-scheduled": {
      icon: false,
      text: "SCHED",
    },
    "published": {
      icon: false,
      text: "PUBLISHED",
    },
    "scheduled": {
      icon: false,
      text: "SCHED",
    },
    "unpublished": {
      icon: false,
      text: "UNPUB",
    },
    "upublished-changes": {
      icon: "fa-edit",
      text: "LIVE",
    },

  };

  /**
   * attribute to pass in the status
   */
  @Input()
  status: string;

  /**
   * attribute to pass in the version status
   */
  @Input()
  versionStatus: string;

  /**
   * Display status
   */
  contentStatus: string;

  /**
   * display Icon
   * @type {string|null}
   */
  statusIcon: string = null;

  /** @inheritdoc */
  ngAfterContentInit() {
    const contentType = this.status ? ContentStatusBadgeComponent.statusTypes[this.status.toLowerCase()] : null;
    if (contentType) {
      this.statusIcon = contentType.icon;
      this.contentStatus = contentType.text;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/content-status-badge/content-status-badge.component.ts